module.exports = {"title":"Contact me","layout":"page","path":"/contact","body":"<p>Not sure I actually need this…</p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./pages/contact/index.md
 ** module id = 477
 ** module chunks = 0
 **/